<div class="card card-long" [ngClass]="{ videoCreative: creative.isVideoCreative }">
	<div *ngIf="!isSocial" class="card-long-bg">
		<img
			[src]="creative?.creativeThumbnail"
			class="card-long-img"
			(click)="openModal(creativeIndex)"
			[ngClass]="{
				c300x600: creative.creativeThumbnail.includes('300x600'),
				c728x90: creative.creativeThumbnail.includes('728x90'),
				c160x600: creative.creativeThumbnail.includes('160x600'),
				c320x50: creative.creativeThumbnail.includes('320x50') || creative.creativeThumbnail.includes('300x50'),
				c468x60: creative.creativeThumbnail.includes('468x60')
			}"
		/>
	</div>
	<div
		*ngIf="isSocial && creative.isIframeExpired == true && creative?.hasSnapshotImage && creative?.snapshotImage"
		class="card-long-bg"
		[ngClass]="{ videoCreative: creative.isVideoCreative }"
	>
		<img
			[src]="creative?.snapshotImage"
			class="card-long-img"
			(click)="openModal(creativeIndex)"
			[ngClass]="{
				c300x600: creative.snapshotImage.includes('300x600'),
				c728x90: creative.snapshotImage.includes('728x90'),
				c160x600: creative.snapshotImage.includes('160x600'),
				c320x50: creative.snapshotImage.includes('320x50') || creative.snapshotImage.includes('300x50'),
				c468x60: creative.snapshotImage.includes('468x60')
			}"
		/>
	</div>
	<div
		*ngIf="isSocial && creative.isIframeExpired == false && creative?.iframeUrl != null"
		class="card-long-bg"
		[ngClass]="{ videoCreative: creative.isVideoCreative }"
	>
		<img
			[src]="creative?.creativeThumbnail"
			class="card-long-img"
			(click)="openModal(creativeIndex)"
			[ngClass]="{
				c300x600: creative.creativeThumbnail.includes('300x600'),
				c728x90: creative.creativeThumbnail.includes('728x90'),
				c160x600: creative.creativeThumbnail.includes('160x600'),
				c320x50: creative.creativeThumbnail.includes('320x50') || creative.creativeThumbnail.includes('300x50'),
				c468x60: creative.creativeThumbnail.includes('468x60')
			}"
		/>
	</div>
	<div
		*ngIf="
			(isSocial && creative.isIframeExpired == true && !creative?.hasSnapshotImage) ||
			(creative.isIframeExpired == false && creative.iframeUrl == null && creative?.creativeThumbnail)
		"
		class="card-long-bg"
		[ngClass]="{ videoCreative: creative.isVideoCreative }"
	>
		<img
			src="../../../../../../assets/images/no-creative-preview-r2.png"
			class="card-long-img"
			(click)="openModal(creativeIndex)"
			[ngClass]="{
				c300x600: creative.creativeThumbnail.includes('300x600'),
				c728x90: creative.creativeThumbnail.includes('728x90'),
				c160x600: creative.creativeThumbnail.includes('160x600'),
				c320x50: creative.creativeThumbnail.includes('320x50') || creative.creativeThumbnail.includes('300x50'),
				c468x60: creative.creativeThumbnail.includes('468x60')
			}"
		/>
	</div>
	<div class="card-long-block" [ngClass]="{ videoCreative: creative.isVideoCreative }">
		<div
			class="card-long-content"
			[ngClass]="creative?.iframeUrl ? 'social-content' : ''"
			[ngClass]="{ videoCreative: creative.isVideoCreative }"
		>
			<div>
				<div class="stats-div" style="padding-top: 0px">
					<div class="inline-div impressions-div">{{ creative?.impressions | number }} Impressions</div>

					<div class="inline-div display nativedisplay {{ creative?.htmlClass }}" *ngIf="creative?.isNative">
						Native
					</div>
					&nbsp;&nbsp;
					<div class="inline-div nativedisplay {{ creative?.htmlClass }}" *ngIf="creative?.isIAB">IAB Display</div>
					<div class="clear"></div>
				</div>
				<div class="stats-div" *ngIf="shouldShow && creative?.isIAB">
					<div class="stats-half-div">
						<span class="sub-head">Ad Interactions</span
						><span class="stats">{{ creative?.adInteractions | number }}</span>
					</div>
					<div class="stats-half-div" style="float: right">
						<span class="sub-head">Ad Interaction Rate</span
						><span class="stats">{{ creative?.adInteractionRate }}%</span>
					</div>
					<div class="clear"></div>
				</div>
				<div class="stats-div">
					<div class="stats-half-div">
						<span class="sub-head">Clicks</span><span class="stats">{{ creative?.clicks | number }}</span>
					</div>
					<div class="stats-half-div" style="float: right">
						<span class="sub-head">Click Rate</span><span class="stats">{{ creative?.clickRate }}%</span>
					</div>
					<div class="clear"></div>
				</div>
				<div *ngIf="isSocial && creative.isVideoCreative" class="stats-div">
					<div class="stats-half-div">
						<span class="sub-head">Completions</span><span class="stats">{{ creative?.completions | number }}</span>
					</div>
					<div class="stats-half-div" style="float: right">
						<span class="sub-head">Completion Rate</span><span class="stats">{{ creative?.completionRate }}%</span>
					</div>
					<div class="clear"></div>
				</div>

				<div *ngIf="isSocial && creative.isVideoCreative" class="stats-div progress-bar">
					<div class="progress-bar-social">
						<div class="sub-head">Started</div>
						<div class="backgroundBar">
							<div
								class="foreGroundBar"
								appTooltip
								title="creative.videoCompletionPercentage.startedTooltip"
								[title]="creative.videoCompletionPercentage.startedTooltip"
								[options]="tooltipOptions"
								[ngStyle]="{
									width:
										(creative.completionRate > 0 && creative.completionRate < 0.025
											? 0.025
											: creative.videoCompletionPercentage.started) + '%',
									'background-color': '#405eb9'
								}"
							></div>
						</div>
					</div>

					<div class="progress-bar-social">
						<div class="sub-head">25% Completed</div>
						<div class="backgroundBar">
							<div
								class="foreGroundBar"
								appTooltip
								title="creative.videoCompletionPercentage.quarterTooltip"
								[title]="creative.videoCompletionPercentage.quarterTooltip"
								[options]="tooltipOptions"
								[ngStyle]="{
									width:
										(creative.completionRate > 0 && creative.completionRate < 0.025
											? 0.025
											: creative.videoCompletionPercentage.quarter) + '%',
									'background-color': '#405eb9'
								}"
							></div>
						</div>
					</div>

					<div class="progress-bar-social">
						<div class="sub-head">50% Completed</div>
						<div class="backgroundBar">
							<div
								class="foreGroundBar"
								appTooltip
								title="creative.videoCompletionPercentage.halfTooltip"
								[title]="creative.videoCompletionPercentage.halfTooltip"
								[options]="tooltipOptions"
								[ngStyle]="{
									width:
										(creative.completionRate > 0 && creative.completionRate < 0.025
											? 0.025
											: creative.videoCompletionPercentage.half) + '%',
									'background-color': '#405eb9'
								}"
							></div>
						</div>
					</div>

					<div class="progress-bar-social">
						<div class="sub-head">75% Completed</div>
						<div class="backgroundBar">
							<div
								class="foreGroundBar"
								appTooltip
								title="creative.videoCompletionPercentage.threeQuartersTooltip"
								[title]="creative.videoCompletionPercentage.threeQuartersTooltip"
								[options]="tooltipOptions"
								[ngStyle]="{
									width:
										(creative.completionRate > 0 && creative.completionRate < 0.025
											? 0.025
											: creative.videoCompletionPercentage.threeQuarters) + '%',
									'background-color': '#405eb9'
								}"
							></div>
						</div>
					</div>

					<div class="progress-bar-social">
						<div class="sub-head">100% Completed</div>
						<div class="backgroundBar">
							<div
								class="foreGroundBar"
								appTooltip
								title="creative.videoCompletionPercentage.completedTooltip"
								[title]="creative.videoCompletionPercentage.completedTooltip"
								[options]="tooltipOptions"
								[ngStyle]="{
									width:
										(creative.completionRate > 0 && creative.completionRate < 0.025
											? 0.025
											: creative.videoCompletionPercentage.completed) + '%',
									'background-color': '#405eb9'
								}"
							></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="isSocial" class="card-engagements-block" [ngClass]="{ videoCreative: creative.isVideoCreative }">
		<div class="each-eng-stat engagements">
			<div class="eng-stat-name">Engagements</div>
			<div class="eng-stat-value">{{ creative?.engagements | number }}</div>
		</div>
		<div class="vertical-line"></div>
		<div class="each-eng-stat">
			<div class="eng-stat-name">Likes</div>
			<div class="eng-stat-value">{{ creative?.likes | number }}</div>
		</div>
		<div class="each-eng-stat">
			<div class="eng-stat-name">Shares</div>
			<div class="eng-stat-value">{{ creative?.shares | number }}</div>
		</div>
		<div class="each-eng-stat">
			<div class="eng-stat-name">Saves</div>
			<div class="eng-stat-value">{{ creative?.saves | number }}</div>
		</div>
		<div class="each-eng-stat">
			<div class="eng-stat-name">Comments</div>
			<div class="eng-stat-value">{{ creative?.comments | number }}</div>
		</div>
		<div class="each-eng-stat">
			<div class="eng-stat-name">Reactions</div>
			<div class="eng-stat-value">{{ creative?.reactions | number }}</div>
		</div>
	</div>
</div>
<div class="clear"></div>
